export default {
    FAMILY_FIRST_MEETING_GUIDE:
    'https://upload.wiosna.org.pl/szlachetnapaczka/document/przewodnik-i-spotkanie-z-rodzina.pdf',
    CRITERIA_FOR_HELP:
    'https://upload.wiosna.org.pl/szlachetnapaczka/document/kryteria_wlaczania_rodzin.pdf',
    RULES_FOR_BENEFITS:
    'https://upload.wiosna.org.pl/szlachetnapaczka/document/przewodnik_po_swiadczeniach.pdf',
    FAMILY_SECOND_MEETING_GUIDE:
    'https://upload.wiosna.org.pl/szlachetnapaczka/document/przewodnik-ii-spotkanie-z-rodzina.pdf',
    FAMILY_DESCRIPTION_GUIDE: 'https://e-learning.wiosna.org.pl/course/view.php?id=96',
    SUPPORTING_WAREHOUSE_STANDARDS:
    ' https://upload.wiosna.org.pl/szlachetnapaczka/document/standardy_magazynow_wspierajacych.pdf ',
    WAREHOUSE_TUTORIAL:
    'https://assets.szlachetnapaczka.pl/tutorials/dane_magazynowe/dodawanie_magazynu/dodawanie_magazynu_player.html',
    REJON_WAREHOUSE_STANDARDS:
    'https://upload.wiosna.org.pl/szlachetnapaczka/document/standardy_magazynow_rejonowych.pdf',
    SZP: 'https://www.szlachetnapaczka.pl',
    GIFT_GIVING_REPORT_GUIDE: 'https://kurs.wiosna.org.pl/course/section.php?id=70',
    AUDIT_VOLUNTEER_GUIDE: 'https://e-learning.wiosna.org.pl/course/view.php?id=132',
    AUDIT_SO_GUIDE: 'https://e-learning.wiosna.org.pl/course/view.php?id=132',
    AUDIT_LEADER_GUIDE: 'https://e-learning.wiosna.org.pl/course/view.php?id=132',
    GIFT_GIVING_REPORT_AUDIT_VOLUNTEER_GUIDE:
    'https://e-learning.wiosna.org.pl/course/view.php?id=132',
    GIFT_GIVING_REPORT_AUDIT_SO_GUIDE: 'https://e-learning.wiosna.org.pl/course/view.php?id=132',
    GIFT_GIVING_REPORT_AUDIT_LEADER_GUIDE: 'https://e-learning.wiosna.org.pl/course/view.php?id=132',
    FILL_INSTRUCTION_COURSE: 'https://kurs.wiosna.org.pl/course/section.php?id=49',
    ADD_FAMILY_GUIDE:
    'https://upload.wiosna.org.pl/szlachetnapaczka/tutoriale/dodaj_historie_rodziny/dodawanie_rodzin_player.html',
    PRIVACY_POLICY: 'https://www.wiosna.org.pl/polityka-prywatnosci/',
    TERMS_OF_SERVICE: 'https://www.wiosna.org.pl/regulamin-serwisu/',
    IMPORTANT_NEEDS_INFO:
    'https://upload.wiosna.org.pl/szlachetnapaczka/document/kluczowe_potrzeby_rodzin_nieuzasadniane.pdf'
};
